import React, { useState, useEffect, useContext } from "react";
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/lab';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { CargoMode } from "app/types/enums";
export default function DashboardAnalytics(props) {

    const { tableData, searchData, widgetSettings, widgetSettingsLocalStorage } = props;

    var currentFromDate = new Date();
    var currentToDate = new Date();
    var defaultFromDate = new Date(currentFromDate.getFullYear(), 0, 1);
    defaultFromDate.setHours(0, 0, 0, 0);
    var defaultToDate = new Date(currentToDate.getFullYear(), 11, 31);
    defaultToDate.setHours(23, 59, 59, 0);
    const [fromDate, setFromDate] = useState(defaultFromDate);
    const [toDate, setToDate] = useState(defaultToDate);
    const [canSearchBookingFrom, setCanSearchBookingFrom] = useState(true);
    const [canSearchBookingTo, setCanSearchBookingTo] = useState(true);
    const [displaySearchBooking, setDisplaySearchBooking] = useState(false);
    const [selectedDurationType, setSelectedDurationType] = useState('12Month');

    const bindTableDataValues = (widgetId) => {
        if (tableData.searchData) {
            switch (widgetId) {
                case 0:
                    // ALL WebPortalAirSeaQuotes
                    return tableData.searchData.filter((s) => s.bookingTypeID === 19 || s.bookingTypeID === 20).length ?? 0;
                case 1:
                    //SEA WebPortalAirSeaQuotes
                    return tableData.searchData.filter((s) => s.bookingTypeID === 20).length ?? 0;
                case 2:
                    //AIR WebPortalAirSeaQuotes
                    return tableData.searchData.filter((s) => s.bookingTypeID === 19).length ?? 0;
                case 3:
                    //FCL WebPortalAirSeaBookings 
                    return tableData.searchData.filter((s) => s.cargoMode === CargoMode.FCL).length ?? 0;
                case 4:
                    // ALL WebPortalAirSeaBookings
                    return tableData.searchData.filter((s) => s.bookingTypeID === 17 || s.bookingTypeID === 18).length ?? 0;
                case 5:
                    //SEA WebPortalAirSeaBookings 
                    return tableData.searchData.filter((s) => s.bookingTypeID === 18).length ?? 0;
                case 6:
                    //AIR WebPortalAirSeaBookings 
                    return tableData.searchData.filter((s) => s.bookingTypeID === 17).length ?? 0;
                case 7:
                    //LCL WebPortalAirSeaBookings
                    return tableData.searchData.filter((s) => s.cargoMode === CargoMode.LCL).length ?? 0;
                default:
            }
        }
    };

    const fromDateOnChange = (date) => {
        setFromDate(date);
        if (date) {
            if (date.toLocaleDateString('en-GB').length !== 10) {
                setCanSearchBookingFrom(false);
            }
            else if (!isNaN(date.getTime())) {
                setCanSearchBookingFrom(true);
            }
            else {
                setCanSearchBookingFrom(false);
            }
        }
        else {
            setCanSearchBookingFrom(false);
        }
    };

    const toDateOnChange = (date) => {
        setToDate(date);
        if (date) {
            if (date.toLocaleDateString('en-GB').length !== 10) {
                setCanSearchBookingTo(false);
            }
            else if (!isNaN(date.getTime())) {
                setCanSearchBookingTo(true);
            }
            else {
                setCanSearchBookingTo(false);
            }
        }
        else {
            setCanSearchBookingTo(false);
        }
    };

    const fromDateValidation = (error) => {
        if (error) {
            setCanSearchBookingFrom(false);
        }
    };

    const toDateValidation = (error) => {
        if (error) {
            setCanSearchBookingTo(false);
        }
    };

    const setDates = (fromDate, toDate, displayDates) => {
        setFromDate(fromDate);
        setToDate(toDate);
        setDisplaySearchBooking(displayDates);
    };

    const searchDataButtonOnClick = () => {
        return searchData(fromDate, toDate);
    };

    const durationTypeOnChange = (event) => {
        if (event.target.value) {
            setSelectedDurationType(event.target.value);
            var currentFromDate = new Date();
            var currentToDate = new Date();
            switch (event.target.value) {
                case '12Month':
                    setDisplaySearchBooking(false);
                    var fromDate = new Date(currentFromDate.getFullYear(), 0, 1);
                    fromDate.setHours(0, 0, 0, 0);
                    var toDate = new Date(currentToDate.getFullYear(), 11, 31);
                    toDate.setHours(23, 59, 59, 0);
                    setDates(fromDate, toDate, false);
                    break;
                case '6Month':
                    setDisplaySearchBooking(false);
                    currentFromDate.setMonth(currentFromDate.getMonth() - 5, 1);
                    currentFromDate.setHours(0, 0, 0, 0);
                    var fromDate = new Date(currentFromDate);
                    currentToDate.setMonth(currentToDate.getMonth() + 1, 0);
                    currentToDate.setHours(23, 59, 59, 0);
                    var toDate = new Date(currentToDate);
                    setDates(fromDate, toDate, false);
                    break;
                case '3Month':
                    setDisplaySearchBooking(false);
                    currentFromDate.setMonth(currentFromDate.getMonth() - 2, 1);
                    currentFromDate.setHours(0, 0, 0, 0);
                    var fromDate = new Date(currentFromDate);
                    currentToDate.setMonth(currentToDate.getMonth() + 1, 0);
                    currentToDate.setHours(23, 59, 59, 0);
                    var toDate = new Date(currentToDate);
                    setDates(fromDate, toDate, false);
                    break;
                case 'custom':
                    setDisplaySearchBooking(true);
                    currentFromDate.setFullYear(currentFromDate.getFullYear() - 1);
                    currentFromDate.setHours(0, 0, 0, 0);
                    var fromDate = new Date(currentFromDate);
                    currentToDate.setHours(23, 59, 59, 0);
                    var toDate = new Date(currentToDate);
                    setDates(fromDate, toDate, true);
                    break;
                default:
                    var fromDate = new Date(currentFromDate.getFullYear(), 0, 1);
                    fromDate.setHours(0, 0, 0, 0);
                    var toDate = new Date(currentToDate.getFullYear(), 11, 31);
                    toDate.setHours(23, 59, 59, 0);
                    setDates(fromDate, toDate, false);
                    break;
            }
        }
    }

    return (
        <div>
            <div style={{ position: 'absolute', right: '30px', zIndex: '1', marginRight: 3 }} >
                <FormControl style={{ width: 155, marginTop: 1 }}>
                    <TextField
                        select
                        label="Duration"
                        value={selectedDurationType}
                        size="small"
                        sx={{ marginTop: 1, marginRight: 1, marginBottom: 1 }}
                        onChange={durationTypeOnChange}>
                        <MenuItem value={'12Month'}>This Year</MenuItem>
                        <MenuItem value={'6Month'}>Last 6 Months</MenuItem>
                        <MenuItem value={'3Month'}>Last 3 Months</MenuItem>
                        <MenuItem value={'custom'}>Custom</MenuItem>
                    </TextField>
                </FormControl>
                {displaySearchBooking &&
                    <DatePicker
                        id="fromDate"
                        name="fromDate"
                        label="From"
                        value={fromDate}
                        onError={fromDateValidation}
                        onChange={fromDateOnChange}
                        renderInput={(params) => <TextField size="small" required sx={{ marginTop: 1, marginRight: 1, width: '145px' }} {...params} />}
                    />
                }
                {displaySearchBooking &&
                    <DatePicker
                        id="toDate"
                        name="toDate"
                        label="To"
                        value={toDate}
                        onError={toDateValidation}
                        onChange={toDateOnChange}
                        renderInput={(params) => <TextField size="small" required sx={{ marginTop: 1, marginBottom: 1, marginRight: 1, width: '145px' }} {...params} />}
                    />
                }
                <Button
                    onClick={searchDataButtonOnClick}
                    style={{ marginTop: 8 }}
                    sx={{ backgroundColor: 'rgba(239, 41, 39, 0.5)', '&:hover': { backgroundColor: '#ef2927' }, color: '#FFF' }}
                    disabled={(!canSearchBookingFrom || !canSearchBookingTo) || tableData.searchDataLoading}>
                    <SearchOutlinedIcon />
                </Button>
            </div>
            <div style={{ position: 'absolute', display: 'flex', flexWrap: 'wrap-reverse', flexDirection: 'column', marginTop: 55, height: '700px', right: '40px' }} >
                {widgetSettings.filter((widget) => { return widget.isDisplay === true }).map(widget =>
                    <Button
                        sx={{
                            zIndex: '1', marginTop: '0px', width: '100px', height: '175px', backgroundColor: widget.backgroundColorOpacity, '&:hover': {
                                backgroundColor: widget.backgroundColor
                            }, transform: `translate(${widget.xPosition}px, ${widget.yPosition}px)`
                        }}
                        variant='contained'
                    >
                        <p>
                            <br></br>
                            {widget.label}
                            <br></br>
                            {widget.bookingType}
                            <br></br>
                            {widget.icon}
                            <br></br>
                            <h2>{bindTableDataValues(widget.widgetId)}</h2>
                        </p>
                    </Button>
                )}
            </div>
        </div>
    );
}
